import React, { useState, useRef, useEffect } from "react";
import videoSource from "../../assets/video.mp4";
import { GiHamburgerMenu } from "react-icons/gi";
import Dropdown from "../../components/shared/Dropdown";
import { useNavigate } from "react-router-dom";
import { useContent } from "../../hooks/useContent";
import { useTranslation } from "react-i18next";

// const statements = ["نصنع لحظات يبقي اثرها في الاعماق", "معا لنصنع المستقبل"];

const NAV_ITEMS = [
  { value: "Home", route: "/" },
  {
    value: "About",
    dropdown: [
      { value: "About arcelia", route: "/about-us" },
      {
        value: "Our philosophy",
        route: "/vision",
      },
      {
        value: "CEO word",
        route: "/ceo-message",
      },
    ],
  },
  { value: "Projects", route: "/projects" },
  { value: "News", route: "/news" },
  { value: "Contact us", route: "/contact-us" },
];

const Header = ({pagetitle = null, subtitle='' }) => {
  // ----------- hooks ------------
  const { t, i18n } = useTranslation();
  const { fetchHero, hero } = useContent();
  const [open, setOpen] = useState(false);
  const [transitioning, setTransitioning] = useState(false);
  const [active, setActive] = useState("الرئيسية");
  const [heroToggler, setHeroToggler] = useState("hero_1");
  const [navToggle, setNavToggle] = useState(false);
  const videoRef = useRef(null);
  const navigate = useNavigate();

  // ------------ functions ------------
  const startVideo = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  const toggleText = () => {
    setTransitioning(true);
    setTimeout(() => {
      setHeroToggler((prevToggler) =>
        prevToggler === "hero_1" ? "hero_2" : "hero_1"
      );
      setTransitioning(false);
    }, 300);
  };

  // ------------ side effects ------------

  useEffect(() => {
    fetchHero();
  }, [i18n.language]);

  useEffect(() => {
    startVideo();
  }, []);

  useEffect(() => {
    const interval = setInterval(toggleText, 3000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <>
      <video style={{ height: "100vh" }} ref={videoRef} loop muted>
        <source src={videoSource} type="video/mp4" />
      </video>
      <div className="header relative flex flex-col items-center justify-start gap-24 text-white" style={{direction: i18n.language === 'ar' ? 'rtl': 'ltr'}}>
        <nav className="flex flex-row justify-end md:justify-evenly items-start md:gap-72 md:py-16 z-10">
       
          <div className="absolute top-7 right-5 md:relative md:top-0 md:right-0 z-10">
            <span
              className="cursor-pointer md:hidden"
              onClick={() => {
                setNavToggle((prev) => !prev);
              }}
            >
              <GiHamburgerMenu />
            </span>
            <ul
              className={`md:flex flex-col md:flex-row gap-4 md:gap-10 my-3 md:my-0 ${
                navToggle ? "flex" : "hidden"
              }`}
            >
              {NAV_ITEMS.map((item, index) => {
                return (
                  <li
                    onClick={() => {
                      index === 1 ? setOpen(!open) : setOpen(false);
                      setActive(item.value);
                      item.route && navigate(item.route);
                    }}
                    className={`nav-item relative w-18 text-white p-1 h-8 cursor-pointer flex flex-row items-center gap-1 ${
                      active === item?.value ? "active font-bold pl-3" : "ml-3"
                    }`}
                    key={index}
                  >
                    {t(item.value)}
                    {item.dropdown && (
                      <Dropdown values={item.dropdown} open={open} />
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
          <img
            className="w-36 md:w-72 pt-5 md:pt-0"
            src={require("../../assets/logo.png")}
            alt="logo"
          />
        </nav>
        {pagetitle && (
          
         
          
        <p
          className={`font-semibold text-center text-5xl p-20 pb-0 relative z-5 `}
        >
       
       {t(`${pagetitle}`)}  
        </p>
     
        )}
        {subtitle && (
             <p
             className={`font-regular text-center text-3xl px-12 relative z-5 `}
           >
              {t(`${subtitle}`)}  
           </p>
        )}
        {!pagetitle && (

        <p
          className={` pt-8 font-semibold text-center text-5xl p-20 relative z-5 transition-all duration-300 ease-in-out ${
            transitioning ? "opacity-0" : "opacity-100"
          }`}
        >
          {hero[heroToggler]}
        </p>
        )}
      </div>
    </>
  );
};

export default Header;
